export default __webpack_public_path__ + "static/media/manageDevicesHover.41d02e74.svg";